import React from 'react'
import { useAuth } from '../../../context/AuthProvider'
import ProjectTable from './ProjectTable'
import EmployeeProject from './EmployeeProject'

const ProjectMain = () => {
    const {user} = useAuth()
  return (
    <>
       {user?.role === 'super-admin' ? (<ProjectTable/>) : (<EmployeeProject/>)} 
    </>  
  )
}

export default ProjectMain